import _Date$now from "@babel/runtime-corejs3/core-js/date/now";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import { getENV } from './env';
import bpitLog from './bpitLog';
import { log, error, warn } from './console';
function staticsLog(config) {
  var env = getENV().env;
  var version = getENV().version;
  var timestamp = _Date$now();
  var params = _Object$assign({
    group: 'yach',
    project: 'yach_31_jssdk',
    env: env,
    version: version,
    timestamp: timestamp
  }, config);
  console.log('jssdk 项目 bpit 上报数据：', params);
  bpitLog(params);
}
export { log, error, warn, staticsLog as bpitLog, getENV };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/utils/index.js
// module id = null
// module chunks = 